import ShopifyLiveSaleGraphQL from "components/Reports/DashboardComponents/ShopifyLiveSale/ShopifyLiveSaleGraphQL";
import * as React from "react";

const ExtShopifyLiveSale = () => {
	return <ShopifyLiveSaleGraphQL />;
};

export default ExtShopifyLiveSale;
